import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/real-return-calculator',
  component: () => import('../../routes/RealReturnCalc.svelte'),
  card: {
    id: 'real-return-calculator',
    title: 'Real Return Calculator',
    description:
      'Calculate your inflation-adjusted investment return using the Fisher equation. See the true purchasing power of your gains.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/real-return-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Real Return Calculator – Inflation-Adjusted Investment Returns',
    description:
      'Free real return calculator using the Fisher equation. Calculate your inflation-adjusted investment return to see the true purchasing power of your gains.',
  },
};

export default meta;
